// Reducers
import entitiesReducer from "core-redux/reducers/entities";
import addMaps from "./maps";

export default (state, action) => {
  const resourcesState = entitiesReducer(state, action);
  const finalState = addMaps(resourcesState, action);
  return finalState;
};
